import {FC} from 'react'
import {ClassifiedPost} from '../../core/_models'

type Props = {
  post: ClassifiedPost
}

const PriceCell: FC<Props> = ({post}) => {
  const formatPrice = (price?: number, currency?: string) => {
    if (price === undefined || price === null) return 'Free'
    if (price === 0) return 'Free'

    const currencySymbol = currency === 'USD' ? '$' : currency || '$'
    return `${currencySymbol}${price.toLocaleString()}`
  }

  return (
    <div className='text-gray-800 fw-bold fs-6'>
      {formatPrice(post.price, post.currency)}
    </div>
  )
}

export {PriceCell}

